// extracted by mini-css-extract-plugin
export default {"logo":"App_logo__7Edbg","resultsAndPlaylist":"App_resultsAndPlaylist__hQNlx"};